import React, { Component } from 'react'


export default class Introduction extends Component {
  render() {
    return (
      <div>
        <section className="colorlib-about" data-section="Publications">
          <div className="colorlib-narrow-content">
            <div className="row">
              <div className="col-md-12">
                <div className="row row-bottom-padded-sm animate-box" data-animate-effect="fadeInLeft">
                  <div className="col-md-12">
                    <div className="about-desc">
                      <span className="heading-meta">Publications</span>
                      <h2 className="colorlib-heading">Publications</h2>
                      <p> P. Dong, Y. Li, Y. Wang, Q. Zhao, <b>T. Lu</b>, T. Guo, J. Ma, B. Yang, H. Wu, H. Huang. <a href="https://doi.org/10.7554/eLife.100037.1">Fat body-derived cytokine Upd2 controls disciplined migration of tracheal stem cells in Drosophila.</a> <i>eLife</i> 13:RP100037 (2024).</p>

                      <p> Y. Li, <b>T. Lu</b><sup>#</sup>, P. Dong, J. Chen, Q. Zhao, Y. Wang, T. Xiao, H. Wu, Q. Zhao, and H. Huang. <a href="https://doi.org/10.1038/s41467-024-46455-w">A single-cell atlas of Drosophila trachea reveals glycosylation-mediated Notch signaling in cell fate specification.</a> <i>Nature Communications</i> 15, 2019 (2024).</p>

                      <p> Y. Li, P. Dong, Y. Yang, T. Guo, Q. Zhao, D. Miao, H. Li, <b>T. Lu</b>, F. Xia, J. Lyu, J. Ma, T. B. Kornberg, Q. Zhang, and H. Huang. <a href="https://doi.org/10.1038/s41467-022-30492-4">Metabolic control of progenitor cell propagation during Drosophila tracheal remodeling.</a> <i>Nature Communications</i> 13, 2817 (2022).</p>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    )
  }
}
